module.exports = __webpack_public_path__ + "img/ep1-6.b4673516.png";